import { MightHaveUserId } from './types';
import { User } from './user/user.model';

export const userIdMatchesUser = (hasUserId: MightHaveUserId, user?: User): boolean => hasUserId?.userId === user?.id;

export const filterByUser = <T extends MightHaveUserId>(hasUserId: T[], user?: User): T[] =>
  hasUserId.filter(has => userIdMatchesUser(has, user));
